"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function createHtmlTab(props, innerHTMlReef) {
  var getHtmlHead = document.querySelector("head");
  var getHtmlBody = document.querySelector("body");
  props.forEach(function (record) {
    var tag = record.tag,
      attrs = record.attrs,
      inner = record.inner;
    var parentNode = document.createElement(tag);
    attrs && Object.keys(attrs).forEach(function (item) {
      parentNode.setAttribute(item, attrs[item]);
    });
    parentNode.innerHTML = inner;
    if (tag === 'style' || tag === 'link') {
      getHtmlHead && getHtmlHead.appendChild(parentNode);
    } else if (tag === 'script') {
      getHtmlBody && getHtmlBody.appendChild(parentNode);
    } else {
      innerHTMlReef && innerHTMlReef.current.appendChild(parentNode);
    }
  });
}
/**
 * configuration  type[array]
 * tag  [style,link,script】
 * attrs [id,class]
 * inner ['',content]
 * [
 {
                tag: 'style',
                attrs: {},
                inner: `body{background: blue}`
            },
 {
                tag: 'link',
                attrs: {
                    ref: 'stylesheet',
                    href: 'css'
                },
            },
 {
                tag: 'div',
                inner: `<div><h1>123213</h1>12321</div>`
            },
 {
                tag: 'script',
                attrs: {
                    type: 'text/javascript',
                    href: 'htt:'
                }
            },
 {
                tag: 'script',
                attrs: {
                    type: 'text/javascript'
                },
                inner:`console.log(1111)`
            }
 ]
 */
var AppendHtmlAttr = /*#__PURE__*/(0, _react.forwardRef)(function (props) {
  var configuration = props.configuration;
  var innerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    createHtmlTab(configuration || [], innerRef);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: innerRef
  });
});
AppendHtmlAttr.displayName = "TCIAppendHtmlAttr";
var _default = exports["default"] = AppendHtmlAttr;